import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Apple pulls another Newton with the iPad",
  "description": "",
  "published": "2010-01-27T00:00:00.000Z",
  "redirect_from": ["/blog/apple-pulls-another-newton-with-the-ipad/swizec/1162"],
  "categories": "Apple, food for thought, Handhelds, intrigues, IPhone, life, Steve Jobs, Technology, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Lately we've been hearing a lot, and I mean a bloody metric shitload, of rumours, speculation and other fun things about the soon-to-be-announced Apple tablet. You know how those Apple fanboys get, the first time hype started building about this thing was several years ago, but lately it's been getting soooo pervasive you just knew it was the real deal this time.`}</p>
    <p>{`Of course after all this hype the features I expected were:`}</p>
    <ul>
      <li parentName="ul">{`the casing is made of solid gold`}</li>
      <li parentName="ul">{`it can make me a sandwich`}</li>
      <li parentName="ul">{`it brings coffee`}</li>
      <li parentName="ul">{`it fits in my pocket`}</li>
      <li parentName="ul">{`it is very very useful`}</li>
      <li parentName="ul">{`it can wipe my arse after I take a dump`}</li>
      <li parentName="ul">{`it can fly me to the moon and back`}</li>
      <li parentName="ul">{`it works like The Guide mk.2 (If you don't know what this means you should be ashamed of yourself)`}</li>
    </ul>
    <p>{`So let's see what Apple gave us:`}</p>
    <ul>
      <li parentName="ul">{`oversized iPhone that can't make calls`}</li>
    </ul>
    <p>{`Errr ... what!? Seriously Apple? Seriously? This!? Really!? We're doing this again!?`}</p>
    <p>{`Ok look, I love Apple, hell I even want an iPhone. And I really believe the devices they create are marvelous pieces of technology that work very well. But this fucking piece of crap is the biggest technological let-down I have ever had the displeasure of seeing.`}</p>
    <p>{`I mean seriously, what the fuck was Apple smoking when they designed this thing? They're supposed to be this sooper innovative company performing feats of magic right before our eyes, but instead, they take all the old technology, add nothing of the new, and call it the next big awesomest thing.`}</p>
    <p>{`Fuck off Apple. Call me when you start making useful and exciting stuff again.`}</p>
    <p>{`At least with the Newton it was marvelous technology that was too far ahead of its time, the iPad is just boring, mundane and boring.`}</p>
    <p>{`Oh and you can tell they know it's boring and useless because it's PRICED THE SAME AS THEIR `}<strong parentName="p">{`OLD`}</strong>{` PRODUCT!`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/6a11f260-6e5d-40e4-a1a5-e6fca38cc7d0/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=6a11f260-6e5d-40e4-a1a5-e6fca38cc7d0",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      